// extracted by mini-css-extract-plugin
var _1 = "BoardActionsPopup_icon__DSdGb";
export { _1 as "icon" }
